import { AntdForm } from '@/common/components/AntdForm'
import { Button, Col, Form, Row } from 'antd'
import { AntdFormRules } from '@/common/components/AntdForm/rules.tsx'
import { Currency } from '@/common/types/region-config.def.ts'
import { Trash2 } from 'lucide-react'
import React from 'react'
import { cn } from '@/utils/style.ts'

interface AntdMultiAdditionalBonusProps {
  hasAdditionalBonus: boolean,
  parentName?: string
  currencyOptions: Currency[]
}

export const AntdMultiAdditionalBonus: React.FC<AntdMultiAdditionalBonusProps> = ({
  hasAdditionalBonus,
  parentName = '',
  currencyOptions,
}) => {

  return (
    <>
      <Row gutter={[20, 10]}>
        <Col>
          <AntdForm.Boolean
            fieldProps={{
              name: ['hasAdditionalBonus'],
              label: 'Has Additional Bonus',
              rules: [AntdFormRules.required],
            }}
          />
        </Col>
      </Row>
      <Row gutter={[20, 10]}>
        <Col>
          <AntdForm.Switch
            fieldProps={{
              name: [parentName, 'additionalBonus', 'subjectToPrevIncomeProof'],
              label: 'Subject to Previous Income Proof',
            }}
          />
          <AntdForm.Switch
            fieldProps={{
              name: [parentName, 'additionalBonus', 'subjectToClawback'],
              label: 'Subject to Clawback',
            }}
          />
        </Col>
        <Form.List name={[parentName, 'additionalBonus', 'paymentYears']}>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ name }, index) => (
                <Col key={index}>
                  <div className={cn('flex justify-between')}>
                    <b>Payment {index + 1}</b>
                    <Button danger htmlType="button" onClick={() => remove(name)} icon={<Trash2 />} />
                  </div>
                  <AntdForm.Select
                    options={currencyOptions.map(x => ({ label: x, value: x }))}
                    fieldProps={{
                      name: [name, 'currency'],
                      label: 'Currency',
                      rules: [AntdFormRules.requiredIf(hasAdditionalBonus)],
                    }}
                  />
                  <AntdForm.Input
                    fieldProps={{
                      name: [name, 'year'],
                      label: 'Fiscal Year',
                      rules: [AntdFormRules.requiredIf(hasAdditionalBonus)],
                    }}
                  />
                  <AntdForm.NumberInput
                    fieldProps={{
                      name: [name, 'yearPayoutAmount'],
                      label: 'Payout Amount',
                      rules: [AntdFormRules.requiredIf(hasAdditionalBonus)],
                    }}
                  />
                  <AntdForm.Input
                    fieldProps={{
                      name: [name, 'yearPayableOn'],
                      label: 'Year Payable On',
                      rules: [AntdFormRules.requiredIf(hasAdditionalBonus)],
                    }}
                  />
                  <AntdForm.Input
                    fieldProps={{
                      name: [name, 'yearConditions'],
                      label: 'Year Conditions',
                      rules: [AntdFormRules.requiredIf(hasAdditionalBonus)],
                    }}
                  />
                </Col>
              ))}
              <Button type="dashed" onClick={() => add()}>
                Add New Payment
              </Button>
            </>
          )}
        </Form.List>
      </Row>
    </>
  )
}